import React, { PureComponent } from 'react';
import { bool, number, object, string } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import I18nProvider from '@fiverr-private/fiverr_context/src/I18nProvider';
import { isTriplePackage } from '../../../../reducers/packages';
import { shouldShowFeature } from '../../../../utils/pricingFactors';
import { getFormattedLabel, getLabel } from '../../../../utils/translation/pricingFactors/label';
import { NUMERIC_TYPE } from '../../../../utils/packagesUtils/constants';
import FormGigItem from '../../FormGigItem';

import './style.scss';

class Feature extends PureComponent {

    formatLabel(i18n) {
        const { type, name, value } = this.props;
        const { subCategoryId } = this.context.general;

        return type === NUMERIC_TYPE
            ? getFormattedLabel(i18n, name, type, value, subCategoryId)
            : getLabel(i18n, name, subCategoryId);
    }

    render() {
        const {
            included,
            id,
            customized,
            displayNotIncluded,
            packageId
        } = this.props;

        if (!shouldShowFeature(included, displayNotIncluded)) {
            return null;
        }

        return (
            <li className={classNames('feature', { included })}>
                <I18nProvider>
                    {({ i18n }) => (<>
                        {this.formatLabel(i18n)}
                        {customized && <FormGigItem packageId={packageId} id={id} quantity={1}/>}
                    </>)}
                </I18nProvider>
            </li>
        );
    }
}

Feature.propTypes = {
    id: number,
    name: string,
    value: number,
    included: bool,
    customized: bool,
    displayNotIncluded: bool,
    packageId: number,
    type: string
};

Feature.defaultProps = {
    customized: false,
    displayNotIncluded: true
};

Feature.contextTypes = {
    general: object
};

const mapStateToProps = ({ packages }, ownProps) => {
    const displayNotIncluded = isTriplePackage(packages);

    return {
        ...ownProps,
        displayNotIncluded
    };
};

export { Feature };

export default connect(mapStateToProps)(Feature);
